import { useEffect, useState } from "react";
import useDebouncedAutoSave from "./useDebouncedAutoSave";
import { DEBOUNCE_TIMEOUT } from "components/common/Constants";

/**
 * Search-field state for a DS `TablePage`, which fires on every keystroke and
 * leaves debouncing to the app. Searches only on more than two characters, so a
 * query is not sent per keystroke. Spread the result straight into
 * `TablePage`'s `search` prop.
 */
const useDebouncedSearch = (
  onSearch: (term: string) => void,
  initialValue = "",
) => {
  const [value, setValue] = useState(initialValue);
  const push = useDebouncedAutoSave(onSearch, DEBOUNCE_TIMEOUT);

  useEffect(() => {
    // Below the threshold is "search nothing", not "keep the last term".
    // Skipping the push instead left the caller filtering on a term the user
    // had already deleted, with the field showing the shorter one.
    push(value.length > 2 ? value : "");
  }, [value, push]);

  return { value, onChange: setValue };
};

export default useDebouncedSearch;
